// eslint-disable-next-line no-restricted-modules
const $ = require('jquery');
const { addCookiePlugin } = require('./jquery.cookie');
const { addAutosizePlugin } = require('./jquery.autosize');
const { throttleOnAnimationFrame } = require('@trello/time');
const { featureFlagClient } = require('@trello/feature-flag-client');

// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
// remove this patch when project is upgraded to jQuery 3.x
$.ajaxPrefilter((s) => {
  if (s.crossDomain) {
    s.contents.script = false;
  }
});

$.extend({ throttleOnAnimationFrame });

addCookiePlugin($);
addAutosizePlugin($);

window.jQuery = $;
window.$ = $;

// jQuery Migrate plugin allows old style 2.x jQuery with version 3.x
// migrateMute false shows verbose console logging when removed/deprecated jQuery methods are used
if (featureFlagClient.get('fep.jquery-3-migrate-verbose', false)) {
  require('jquery-migrate');
}

if (featureFlagClient.get('fep.jquery-ui-1.13', false)) {
  // jQuery-ui 1.13.1
  require('../vendor/jquery.ui/widget');
  require('../vendor/jquery.ui/widgets/mouse');
  require('../vendor/jquery.ui/core');
  require('../vendor/jquery.ui/position');
  require('../vendor/jquery.ui/widgets/draggable');
  require('../vendor/jquery.ui/widgets/droppable');
  require('../vendor/jquery.ui/widgets/sortable');
} else {
  // jQuery-ui 1.10.3
  require('../vendor/jquery.ui.core');
  require('../vendor/jquery.ui.widget');
  require('../vendor/jquery.ui.mouse');
  require('../vendor/jquery.ui.position');
  require('../vendor/jquery.ui.draggable');
  require('../vendor/jquery.ui.droppable');
  // note: remove sortable.patch3 and sortable.patch4 along with jQuery1.10
  require('../vendor/jquery.ui.sortable');
}

// Apparently those stupid files don't close over the jQuery variable.
// So we can't delete it after we're done.
// delete window.jQuery;
// delete window.$;

module.exports = $;
